/* eslint-disable import/prefer-default-export */
import { SetShouldShowBadgePayload, SetVaultItemPayload, SetVaultItemsPayload } from './types';

import ActionTypes from './actionTypes';

export interface SetVaultItemsAction {
    type: typeof ActionTypes.SET_VAULT_ITEMS;
    payload: SetVaultItemsPayload;
}

export interface SetVaultItemAction {
    type: typeof ActionTypes.SET_VAULT_ITEM;
    payload: SetVaultItemPayload;
}

export interface SetShouldShowBadgeAction {
    type: typeof ActionTypes.SET_SHOULD_SHOW_BADGE;
    payload: SetShouldShowBadgePayload;
}

export function setVaultItems(payload: SetVaultItemsPayload): SetVaultItemsAction {
    return {
        type: ActionTypes.SET_VAULT_ITEMS,
        payload,
    };
}

export function setVaultItem(payload: SetVaultItemPayload): SetVaultItemAction {
    return {
        type: ActionTypes.SET_VAULT_ITEM,
        payload,
    };
}

export function setShouldShowBadge(payload: SetShouldShowBadgePayload): SetShouldShowBadgeAction {
    return {
        type: ActionTypes.SET_SHOULD_SHOW_BADGE,
        payload,
    };
}

export type VaultAction = SetVaultItemsAction | SetVaultItemAction | SetShouldShowBadgeAction;
export type ActionCreator = typeof setVaultItems | typeof setVaultItem | typeof setShouldShowBadge;
